module.exports = __webpack_public_path__ + "./images/docent-man-100.png?d36ad880ca395c8ddb8fd311830acd8e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/docent-man-100.png
// module id = 89
// module chunks = 0